export let DataStateKey;
(function (DataStateKey) {
  DataStateKey["value"] = "value";
  DataStateKey["prefilled"] = "prefilled";
  DataStateKey["prefillType"] = "prefillType";
  DataStateKey["completed"] = "completed";
  DataStateKey["skipped"] = "skipped";
  DataStateKey["validation"] = "validation";
  DataStateKey["errorMessage"] = "errorMessage";
  DataStateKey["showTooltip"] = "showTooltip";
})(DataStateKey || (DataStateKey = {}));